import React from 'react';
import {ReactElement} from 'react';
import AurIcon, {IconNames, IconColors} from '../../../common/aur-icon/AurIcon';
import {Link} from 'react-router-dom';

const Icon: React.FC = () => {
  const listAllIcons = () => {
    const results: ReactElement[] = [];
    for (const iconEnum in IconNames) {
      const enumeration = IconNames[iconEnum as keyof typeof IconNames];
      results.push(
        <span style={{margin: '3px'}}>
          <AurIcon icon={enumeration} />
        </span>
      );
    }
    return results;
  };

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Icons</h1>
        <div>Displays an icon from a currated set of Aurora Icons.</div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <h3>Colors</h3>
          <div>
            <table>
              <thead>
                <tr>
                  <td style={{minWidth: '100px'}}>Primary</td>
                  <td style={{minWidth: '100px'}}>Secondary</td>
                  <td style={{minWidth: '100px'}}>Success</td>
                  <td style={{minWidth: '100px'}}>Warning</td>
                  <td style={{minWidth: '100px'}}>Critical</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <AurIcon icon={IconNames.Add} color={IconColors.Primary} />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.Add}
                      color={IconColors.Secondary}
                    />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Add} color={IconColors.Success} />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Add} color={IconColors.Warning} />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Add} color={IconColors.Critical} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <AurIcon
                      icon={IconNames.BarChart}
                      color={IconColors.Primary}
                    />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.BarChart}
                      color={IconColors.Secondary}
                    />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.BarChart}
                      color={IconColors.Success}
                    />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.BarChart}
                      color={IconColors.Warning}
                    />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.BarChart}
                      color={IconColors.Critical}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <AurIcon icon={IconNames.Copy} color={IconColors.Primary} />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.Copy}
                      color={IconColors.Secondary}
                    />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Copy} color={IconColors.Success} />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Copy} color={IconColors.Warning} />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.Copy}
                      color={IconColors.Critical}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <AurIcon icon={IconNames.Edit} color={IconColors.Primary} />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.Edit}
                      color={IconColors.Secondary}
                    />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Edit} color={IconColors.Success} />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Edit} color={IconColors.Warning} />
                  </td>
                  <td>
                    <AurIcon
                      icon={IconNames.Edit}
                      color={IconColors.Critical}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style={{marginBottom: '32px'}}>
          <h3>Sizes</h3>
          <div>
            <table>
              <thead>
                <tr>
                  <td style={{minWidth: '80px'}}>Small</td>
                  <td style={{minWidth: '80px'}}>Medium</td>
                  <td style={{minWidth: '80px'}}>Large</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <AurIcon icon={IconNames.Add} size="small" />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Add} size="medium" />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Add} size="large" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <AurIcon icon={IconNames.BarChart} size="small" />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.BarChart} size="medium" />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.BarChart} size="large" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <AurIcon icon={IconNames.Copy} size="small" />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Copy} size="medium" />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Copy} size="large" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <AurIcon icon={IconNames.Edit} size="small" />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Edit} size="medium" />
                  </td>
                  <td>
                    <AurIcon icon={IconNames.Edit} size="large" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div>
          <h3>Full List</h3>
          <div>{listAllIcons()}</div>
        </div>
      </div>
    </>
  );
};

export default Icon;
